import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFeatureTheme } from '../../theme/hooks/useFeatureTheme';

export default function ListPageHeader({
  title,
  subtitle,
  action,
  /** @deprecated Prefer `action` — kept for callers that pass `actions` */
  actions,
  sx = {},
}) {
  const { semantic, typography } = useFeatureTheme();
  const headerAction = action ?? actions;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
        ...sx,
      }}
    >
      <Box>
        {title ? (
          <Typography
            variant="h5"
            sx={{
              fontWeight: typography.fontWeightBold ?? 700,
              color: semantic.text.primary,
            }}
          >
            {title}
          </Typography>
        ) : null}
        {subtitle ? (
          <Typography
            variant="body2"
            sx={{
              color: semantic.text.secondary,
              mt: 0.5,
              maxWidth: 640,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {headerAction ? <Box sx={{ flexShrink: 0 }}>{headerAction}</Box> : null}
    </Box>
  );
}
